import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { MenuScreen } from "@/features/user/menu-screen"
import type { MenuPayload } from "@/features/user/types"

type Props = {
  menu: MenuPayload
}

/**
 * The same menu screen a seated diner reads. No `diner` prop, because there is
 * no visit — the restaurant is the slug in the URL, and adding a dish writes to
 * localStorage rather than to a bill.
 */
export default function UserPickupMenu() {
  const { menu } = usePage<Props>().props

  return (
    <UserLayout wide>
      <MenuScreen menu={menu} serviceContext="pickup" />
    </UserLayout>
  )
}
